import { createContext } from "react";

export type InterceptorContextType = {
};

export const InterceptorContext = createContext<InterceptorContextType>(null!);
